export function countChangedLevelTypes(
  savedLevels: ReadonlyArray<{ uniqueId: string; type: string }>,
  previousLevels: ReadonlyArray<{ uniqueId: string; type: string }>
): number {
  return savedLevels.filter((level) => {
    const previous = previousLevels.find(
      (previousLevel) => previousLevel.uniqueId === level.uniqueId
    );
    return Boolean(previous && previous.type !== level.type);
  }).length;
}
